import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './Hero.css';
import heroImage from '../media/hero.png';
import { FaGithub, FaLinkedin, FaEnvelope, FaBriefcase, FaRocket, FaMapMarkerAlt, FaCircle } from 'react-icons/fa';

const Hero = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      easing: 'ease-out-cubic',
    });
  }, []);



  return (
    <section className="hero" id="home">
      <div className="hero-background">
        <div className="gradient-orb orb-1"></div>
        <div className="gradient-orb orb-2"></div>
        <div className="gradient-orb orb-3"></div>
      </div>

      <div className="container hero-container">
        <div className="hero-content">
          <div className="hero-text" data-aos="fade-right">
            <p className="hero-greeting">Hi there, I'm</p>
            <h1 className="hero-name">
              <span className="gradient-text">Mahmoud Salah Elfar</span>
            </h1>
            <h2 className="hero-title">
              Aspiring Full Stack .NET Developer — DevOps Enthusiast
            </h2>
            <p className="hero-description">
              I craft beautiful, functional digital experiences that bring ideas to life.
              Passionate about clean code, elegant design, and innovative solutions.
            </p>

            <div className="hero-cta" data-aos="fade-up" data-aos-delay="200">
              <a href="#contact" className="btn btn-primary">
                Get In Touch
              </a>
              <a href="#projects" className="btn btn-outline">
                View My Work
              </a>
            </div>

            <div className="hero-social" data-aos="fade-up" data-aos-delay="400">
              <a href="https://github.com/ma7moudsala7elfar" target="_blank" rel="noopener noreferrer" className="social-link">
                <FaGithub />
              </a>
              <a href="https://linkedin.com/in/ma7moudsala7elfar" target="_blank" rel="noopener noreferrer" className="social-link">
                <FaLinkedin />
              </a>
              <a href="mailto:ma7moudsala7elfar@gmail.com" className="social-link">
                <FaEnvelope />
              </a>
            </div>
          </div>

          <div className="hero-stats-wrapper" data-aos="fade-left" data-aos-delay="200">
            <div className="profile-card" data-aos="fade-up" data-aos-delay="700">
              <div className="profile-image-container">
                <img src={heroImage} alt="Profile" className="profile-image" />
                <div className="profile-border"></div>
              </div>
              <div className="profile-info">
                <div className="profile-header">
                  <div>
                    <h3 className="profile-name">Mahmoud Salah Elfar</h3>
                    <p className="profile-role">Full Stack .NET Developer</p>
                  </div>
                  <div className="profile-status">
                    <FaCircle className="status-dot" />
                    <span>Available</span>
                  </div>
                </div>
                <div className="profile-meta">
                  <div className="profile-location">
                    <FaMapMarkerAlt />
                    <span>Kafr El-Sheikh, Egypt</span>
                  </div>
                </div>
                <p className="profile-bio">
                  Passionate about creating elegant solutions to complex problems.
                </p>
              </div>
            </div>
            <div className="stats-grid">
              <div className="stat-card" data-aos="fade-up" data-aos-delay="300">
                <div className="stat-icon">
                  <FaBriefcase />
                </div>
                <div className="stat-content">
                  <h3 className="stat-value">1+</h3>
                  <p className="stat-label">Years Experience</p>
                </div>
              </div>

              <div className="stat-card" data-aos="fade-up" data-aos-delay="400">
                <div className="stat-icon">
                  <FaRocket />
                </div>
                <div className="stat-content">
                  <h3 className="stat-value">10+</h3>
                  <p className="stat-label">Projects Completed</p>
                </div>
              </div>

              <div className="stat-card" data-aos="fade-up" data-aos-delay="600">
                <div className="stat-icon">
                  <FaEnvelope />
                </div>
                <div className="stat-content">
                  <h3 className="stat-value">24/7</h3>
                  <p className="stat-label">Available</p>
                </div>
              </div>
            </div>


          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
